module.exports = __webpack_public_path__ + "static/media/Ban on aircrafts and vessels.f5049d79.png";